import { SectionError } from '@components/ui/error';
import { SectionLoader } from '@components/ui/loader';

import { Route } from '@/constants';
import { CreatePrePurchaseComponent } from '@/modules/purchase/pre-purchase/create-pre-purchase';
import { CreatePrePurchaseProvider } from '@/modules/purchase/pre-purchase/create-pre-purchase/create-pre-purchase.context';

import { usePrePurchaseDetails } from './pre-purchase-details.hook';

export const PrePurchaseDetails = () => {
    const { data, isLoading, isFetching, isError, error } =
        usePrePurchaseDetails();

    if (isLoading || isFetching) {
        return <SectionLoader />;
    }

    if (isError) {
        return (
            <SectionError error={error} fallbackPath={Route.PRE_PURCHASES} />
        );
    }

    return (
        <CreatePrePurchaseProvider>
            <CreatePrePurchaseComponent
                initialValues={data?.data}
                isEditMode={true}
            />
        </CreatePrePurchaseProvider>
    );
};

PrePurchaseDetails.displayName = 'PrePurchaseDetails';
